import type { SubscriptionAdditionalQuotaUnit } from '@/types/dtos/transactions/subscription.dto';
import type { SubscriptionBillingPeriod, SubscriptionPlan } from '@/types/dtos/transactions/subscription-plan.dto';
import { computeOrganizationRenewalAmount } from '@/helpers/organization-subscription-pricing';

/** Matches recurring row formatting in `organization-subscription-checkout.modal.tsx`. */
export function getCheckoutRecurringPriceDisplay(
  t: (key: string) => string,
  plan: SubscriptionPlan,
  lineBilling: SubscriptionBillingPeriod,
  additionalQuotaUnits: SubscriptionAdditionalQuotaUnit[] | undefined,
): {
  recurringFull: number | undefined;
  recurringDisplayEur: number | undefined;
  amountLabel: string;
  periodMid: string;
  periodTail: string;
} {
  const recurringFullRaw = computeOrganizationRenewalAmount(plan, additionalQuotaUnits);
  const recurringFull = Number.isFinite(recurringFullRaw) ? recurringFullRaw : undefined;
  const isYearBilling = lineBilling === 'YEAR';
  const recurringDisplayEur =
    recurringFull === undefined
      ? undefined
      : isYearBilling
        ? Math.round((recurringFull / 12) * 100) / 100
        : recurringFull;

  const annualPriceSuffixFull = t('subscription.organization.planPage.subscriptionCheckoutRecurringPerMoAnnualSuffix');
  const annualPriceSuffixCommaIdx = annualPriceSuffixFull.indexOf(',');
  const annualPriceSuffixHead =
    annualPriceSuffixCommaIdx >= 0 ? annualPriceSuffixFull.slice(0, annualPriceSuffixCommaIdx) : annualPriceSuffixFull;
  const annualPriceSuffixTail =
    annualPriceSuffixCommaIdx >= 0 ? annualPriceSuffixFull.slice(annualPriceSuffixCommaIdx) : '';
  const priceSuffixTail = isYearBilling ? annualPriceSuffixTail : `, ${t('event.checkoutModal.excludingVat')}`;

  const periodShort = isYearBilling
    ? t('subscription.organization.planPage.billingYearShort')
    : t('subscription.organization.planPage.billingPeriodShort');

  const periodMid = isYearBilling ? annualPriceSuffixHead : ` /${periodShort}`;

  const amountLabel = recurringDisplayEur !== undefined ? `€${recurringDisplayEur.toFixed(2)}` : '—';

  return {
    recurringFull,
    recurringDisplayEur,
    amountLabel,
    periodMid,
    periodTail: priceSuffixTail,
  };
}
